import { buildRef, getUrlParams, _sendStat, _adReport, uaTest, toObject, setDeviceId, getOsName,getDomain, isMatchApp } from "../utils/utils";
import SessionStorage from "../utils/sessionStorage";
import LocalStorage from "../utils/localStorage";
import Cookies from '../utils/cookies';
import Base from "./base";

class MiotStatBase extends Base {
  sendStat: (c: any, d?: string) => any;
  config: { env: string, mode: string, spmA: string };
  buildRef: (c: any) => string;
  getUrlParams: (url: string, key: string) => any;
  debug: any;
  viewTime: number;
  lastReportTime: number;
  currentView: any;
  lastViewTime: number;
  private cacheArray: any[];
  private appQueue: any[];
  private interval: any;
  timer: any;
  private adReport: any;
  private pendding: boolean;
  private isNotRn: boolean;
  private timeSum: number;
  device_id: string
  constructor(config, sendStat, adReport?: any, debug?: boolean) {
    super();
    // 传入方法
    this.sendStat = sendStat || _sendStat;
    this.config = config || { env: 'staging', mode: 'shop', spmA: 'H5' }
    this.adReport = adReport || _adReport;
    this.buildRef = buildRef;
    this.getUrlParams = getUrlParams;
    this.debug = debug || false;
    this.viewTime = 0;
    this.lastReportTime = 0;
    this.currentView = null;
    this.lastViewTime = 0;
    this.cacheArray = [];
    this.appQueue = []; // 事件队列
    this.interval = null;
    this.pendding = false;
    this.timeSum = 0;
    this.isNotRn = false;
    this.platform = 'WEB'
    if (LocalStorage.getItem("device_id")) {
      this.device_id = LocalStorage.getItem("device_id")
    } else {
      this.device_id = setDeviceId()
      LocalStorage.setItem("device_id", 'xmdevice_' + this.device_id)
    }
    this.urlParseUtm();

  }
  init() {
    //启动定时上报
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.reportCached(false);
    }, 1000);
  }

  stat(eventName: string, key: string, val: string, iid: string, params: StatProps) {
    const date = new Date();
    if (this.lastReportTime === 0) {
      this.init();
    }

    if (key) {
      key = `${key}`;
    }
    if (val) {
      val = `${val}`;
    }
    if (Array.isArray(iid)) {
      iid = JSON.stringify(iid);
    }
    let value = `${val}`;
    if (params.cm_id) {
      this.adReport({
        cm_id: params.cm_id,
        iid: params.iid,
        event: eventName,
        client_time: new Date().getTime() / 1000,
        spm: params.spm,
        scm: params.scm
      })
    }
    // 兜底UTM上报
    const umt: any = params?.utm
    if (!umt.mtm) {
      const KEY_NAME = '_utm_data';
      let localSession: any = {};
      let localCookie: any = {};
      try {
        if (sessionStorage.getItem(KEY_NAME)) {
          localSession = JSON.parse(sessionStorage.getItem(KEY_NAME));
        }
        if (Cookies.get(KEY_NAME)) {
          localCookie = JSON.parse(Cookies.get(KEY_NAME));
        }
        
      } catch (e) {
        console.log(e)
      }
      const mtm = getUrlParams('g_utm', window?.location.href)
        || localSession.mtm
        || localCookie.mtm
        || ''
      params.utm = { mtm }
    }

    if (eventName == "VIEW") {

      this.viewTime = date.getTime();
      // 取消webview的800ms判断，webview默认少报一个web的spm，后边的h5会出现丢spm情况
      if (this.viewTime - this.lastViewTime < 800) {
        this.lastViewTime = date.getTime();
        return;
      }
      this.lastViewTime = date.getTime();
      this.reportStat(eventName, key, value, iid, params);
      return this.reportCached(true);
    } else if (eventName === "TOUCH" || eventName === "VIEWEND" || eventName === "INFO" || eventName === "CUSTOM") {
      this.reportStat(eventName, key, value, iid, params);
      return this.reportCached(true);
    } else {
      this.reportStat(eventName, key, value, iid, params);
      return this.reportCached(false);
    }


  }

  createNode(page: string, id: string, eventName: string, time: number, spend: number, ref: string, params: StatProps) {
    let spm = (params && params.spm) || "";
    let spmref = "";
    if (eventName == "VIEW") { // 如果需要这里添加其他事件类型spmref的支持
      spmref = this.getUrlParams(id, "spmref");
      if (spmref == "" && this.getUrlParams(id, "trace") != "") {
        const traceInfo = this.getUrlParams(id, "trace").split("-");
        if (traceInfo.length >= 2) {
          spmref = `h5.${traceInfo[0]}-${traceInfo[1]}.${traceInfo[2] ||
            0}.${traceInfo[3] || 0}.${Math.floor(
              Math.random() * Math.pow(10, 8)
            )}`;
        }
      }
    }
    if (page == "Web" && eventName == "VIEW") {
      spm = `h5.${(params && params.pageId) ||
        "$Web$"}.0.0.${Math.floor(Math.random() * Math.pow(10, 8))}`;
    }
    return {
      page: page,
      id: id,
      event: eventName,
      time: time,
      spend: spend,
      ref: ref,
      spm: spm,
      spmref: decodeURIComponent(spmref),
      iid: params.iid,
      idlist: params.iid,
      scm: params.scm,
      scmref: params.scmref || getUrlParams(location.href, 'scmref') || '',
      scmref_step: params.scmref_step || parseInt(getUrlParams(location.href, 'scmref_step')) || 0,
      uri: params.uri,
      uriref: params.uriref,
      xiaomi_id: params.xiaomi_id,
      utm: params.utm,
      params: params.params,
      event_id: params.event_id,
      session: params.session
    };
  }


  private rnSend(params: string) {
    window._MiHomeStore.rnSendWebEvent('reportStat', params);
  }
  requestNode(eventName: string, key: string, value: string, iid: string, params: StatProps) {
    const date = new Date();
    let node = {};
    let page = params.page || '';
    switch (eventName) {
      case "VIEW":
        // let page = key.replace("com.xiaomi.smarthome.shop.", "");
        // page = page.replace("com.xiaomi.smarthome.", "");
        page = key;   // view事件中key代表pageName
        node = this.createNode(
          page,
          value,
          eventName,
          date.getTime(),
          0,
          "",
          params
        );

        this.cacheArray.push(node);
        try {
          SessionStorage.setItem(
            "preUrl",
            SessionStorage.getItem("curUrl") || ""
          );
          SessionStorage.setItem("curUrl", value || "");
        } catch (error) { }

        this.currentView = node;
        // this.cacheView = this.currentView;
        break;
      case "VISIBLE":
        if (this.currentView == null) {
          return;
        }
        node = this.createNode(
          params.page || this.currentView.page,
          this.currentView.id,
          eventName,
          date.getTime(),
          0,
          "",
          params
        );
        node['area'] = params.area; // 代表传入的area
        this.cacheArray.push(node);
        break;
      case "VIEWEND":
        if (this.currentView == null) {
          return;
        }
        node = this.createNode(
          params.page || this.currentView.page,
          this.currentView.id,
          eventName,
          date.getTime(),
          date.getTime() - this.viewTime,
          "",
          params
        );
        this.cacheArray.push(node);
        break;
      case "INFO":
        if (this.currentView == null) {
          return;
        }
        node = this.createNode(
          params.page || this.currentView.page,
          this.currentView.id,
          eventName,
          date.getTime(),
          date.getTime() - this.viewTime,
          "",
          params
        );
        this.cacheArray.push(node);
        break;
      case "TOUCH":
        if (this.currentView == null) {
          break;
        }
        node = this.createNode(
          params.page || this.currentView.page,
          this.currentView.id,
          eventName,
          date.getTime(),
          0,
          "",
          params
        );
        node['area'] = key;
        this.cacheArray.push(node);

        if (key != "visit") {
          try {
            let ActionStack: any = SessionStorage.getItem("routeStack");
            if (ActionStack) {
              ActionStack = JSON.parse(ActionStack);
            } else {
              ActionStack = [];
            }
            ActionStack.push(node);
            SessionStorage.setItem("routeStack", JSON.stringify(ActionStack));
          } catch (e) { }
        }
        break;
      case "CUSTOM":
        if (this.currentView == null) {
          break;
        }
        node = this.createNode(
          params.page || this.currentView.page,
          this.currentView.id,
          params.eventName,
          date.getTime(),
          0,
          "",
          params
        );
        node['area'] = key;
        this.cacheArray.push(node);
        break;
      default:
        break;
    }
  }
  reportCached(isForce: boolean) {
    const date = new Date();

    if (
      !isForce &&
      (this.cacheArray.length < 1 ||
        date.getTime() - this.lastReportTime < 5000 - 1)
    ) {
      this.init();
      return;
    } else {
      // clearInterval(this.timer);
    }
    if (this.cacheArray.length == 0) {
      return;
    }

    this.lastReportTime = date.getTime();
    let system = getOsName().system
    let os_name = ''
    let os_version = ''
    if (system) {
      os_name = system.split(' ')[0]
      os_version = system.split(' ')[system.split(' ').length - 1]
    }
    let data = this.cacheArray.map(item => {
      let e = {
        env: this.config.env || 'staging',
        specs: {
          device_id: this.device_id,
          device_name: getOsName().device,
          os_name,
          os_version
        },
        event: {
          client_time: item.time,
          params: {}
        }
      };

      if (item.spm) {
        e.event['spm'] = item.spm;
      }
      if (item.spmref) {
        e.event['spmref'] = item.spmref;
      }
      if (item.scm) {
        e.event['scm'] = item.scm;
      }
      if (item.scmref) {
        e.event['scmref'] = item.scmref;
      }
      if (item.event) {
        e.event['event_type'] = item.event
      }
      if (item.xiaomi_id) {
        e.event['xiaomi_id'] = item.xiaomi_id
      }
      if (item.id) {
        e.event['uri'] = encodeURIComponent(encodeURIComponent(item.id))
      } else if (item.uri) {
        e.event['uri'] = encodeURIComponent(encodeURIComponent(item.uri))
      }

      if (item.iid) {
        e.event['params'] = toObject(decodeURIComponent(item.iid))
        if (item.spend) {
          e.event['params'] = Object.assign(e.event['params'], {
            'spend': encodeURIComponent(item.spend)
          })
        }
      }
      if (item.area) {
        e.event['params'] = Object.assign(e.event['params'], {
          'area': encodeURIComponent(item.area)
        })
      }
      if (item.params) {
        for (let key in item.params) {
          if (item.params.hasOwnProperty(key)) {
            if (typeof item.params[key] !== 'object') {
              item.params[key] = encodeURIComponent(item.params[key])
            } else {
              item.params[key] = encodeURIComponent(JSON.stringify(item.params[key]))
            }
          }
        }
        e.event['params'] = Object.assign(e.event['params'], item.params)
      }
      if (item.utm) {
        e.event['utm'] = item.utm
      }
      e.event['event_id'] = item.event_id

      if (item.session) {
        e.event['session'] = item.session
      }
      e.event['scmref_step'] = item.scmref_step;



      if (item.event == "VIEW") {
        // e.e.referer = encodeURIComponent(document.referrer || '');
        try {
          let preUrl = SessionStorage.getItem("preUrl");
          const urlReg = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/; //正则匹配域名
          const docReferer = urlReg.exec(document.referrer)[0];
          if (docReferer != urlReg.exec(document.location.href)[0]) {
            e.event['uriref'] = encodeURIComponent(encodeURIComponent(document.referrer));
          } else if (preUrl) {
            e.event['uriref'] = encodeURIComponent(encodeURIComponent(preUrl || ""));
          } else {
            e.event['uriref'] = "";
          }
        } catch (error) {
          e.event['uriref'] = "";
        }
      }
      if (item.uriref) {
        e.event['uriref'] = encodeURIComponent(encodeURIComponent(item.uriref))
      }
      return e;
    });
    this.cacheArray = [];
    if (this.debug) {
      console.log(data);
    }
    return this.sendStat(data, this.config.mode);
  }
  // 增加判断是否在app内
  reportStat(eventName: string, key: string, value: string, idlist: string, jsonObject: StatProps) {

    // 如果是h5在native里打开，先尝试用native去上报，webview上有native注入的方法，先判断是否有这个方法
    if (uaTest().app && !this.isNotRn && isMatchApp()) {
      if (!jsonObject.scmref) {
        jsonObject.scmref = getUrlParams(location.href, 'scmref') || '';
        jsonObject.scmref_step = parseInt(getUrlParams(location.href, 'scmref_step')) || 0;
      }
      let params = JSON.stringify({
        event: eventName,
        key: key,
        val: value,
        iid: idlist || jsonObject.iid,
        jsonObject: {
          page_id: jsonObject.b, // 为了兼容RN的桥才叫page_id，其实是b位
          ...jsonObject
        },
      });
      // 等待wwebview的注入成功后再调用，这里没有用定时器去轮询，担心定时器出问题
      if (!Boolean(window._MiHomeStore && window._MiHomeStore.rnSendWebEvent)) {
        this.appQueue.push(params)
        clearInterval(this.interval);

        // 这里设置2s就不再走RN上报，是因为有可能降级走的native的webview，只能走h5，
        this.interval = setInterval(() => {
          if (Boolean(window._MiHomeStore && window._MiHomeStore.rnSendWebEvent)) {
            this.timeSum = 0
            this.throttleSend()
          } else {
            this.timeSum = this.timeSum + 300
            if (this.timeSum >= 2000) {
              this.timeSum = 0
              this.isNotRn = true
              clearInterval(this.interval);
              this.throttleWebSend()
            }
          }

        }, 300);

      } else {
        if (!this.pendding) {
          this.rnSend(params);
          this.pendding = true
        } else {
          this.appQueue.push(params)
        }
        this.timeSum = 0
        this.throttleSend()

      }
      return
    } else {
      this.requestNode(eventName, key, value, idlist, jsonObject);
    }

  }
  private throttleSend() {
    // 因为RN的桥接方法是用location.href实现的，如果触发太快，就会造成RN只拦截到最后一个记录，所以加了定时器，10ms只是测试通过的经验值
    clearInterval(this.interval);
    this.interval = setInterval(() => {
      if (this.appQueue.length === 0) {
        clearInterval(this.interval);
        this.pendding = false
      } else {
        this.rnSend(this.appQueue[0]);
        this.appQueue.shift()
      }
    }, 10);
  }
  private throttleWebSend() {
    this.pendding = false
    if (this.appQueue.length !== 0) {
      this.appQueue.forEach(e => {
        let { event, key, val, iid, jsonObject } = JSON.parse(e)
        // console.log(event, key, val, iid, jsonObject,'event, key, val, iid, jsonObject')
        this.requestNode(event, key, val, iid, jsonObject);
      });
      this.appQueue = []
      return this.reportCached(true);
    }

  }
  private urlParseUtm() {
    const KEY_NAME = '_utm_data';
    const url = location.href
    const _utm_data = {
        mtm: '',
        device_id: ''
    }
    let localSession: any = {};
    let localCookie: any = {};
    try {
      if (sessionStorage.getItem(KEY_NAME)) {
        localSession = JSON.parse(sessionStorage.getItem(KEY_NAME));
      }
      if (Cookies.get(KEY_NAME)) {
        localCookie = JSON.parse(Cookies.get(KEY_NAME));
      }
    } catch (e) {
      console.log(e)
    }

    _utm_data.mtm = getUrlParams(url, 'g_utm') || localSession?.mtm || localCookie?.mtm || ''
    _utm_data.device_id = getUrlParams(url, 'g_device_id') || localSession?.device_id || localCookie?.device_id || ''

    sessionStorage.setItem(KEY_NAME, JSON.stringify(_utm_data))
    Cookies.set(KEY_NAME, JSON.stringify(_utm_data), getDomain())
  }
}

export default MiotStatBase;
